import React, { Component } from "react";
import { connect } from "react-redux";
import { addToCart } from "../../../redux/actions/Cart.Action";
import { Modal } from "react-bootstrap";
class AddToCartModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      note: "",
      place: 0,
      qty: 1,
      i: Math.random(),
    };
  }
  handleCloseModal = () => {
    this.setState({ note: "", place: 0, qty: 1 });
    this.props.hideTrigger();
  };
  handleIncreaseQty = () => {
    this.setState({ qty: this.state.qty + 1 });
  };
  handleDecreaseQty = () => {
    this.setState({ qty: this.state.qty - 1 || 1 });
  };
  handlePlace = (e) => {
    this.setState({ place: e });
  };
  handleNote = (e) => {
    const str = e.value;
    var strReplace = str
      .replace(
        /(?:[\u2700\-\u27bf]|(?:\ud83c[\udde6\-\uddff]){2}|[\ud800\-\udbff][\udc00\-\udfff]|[\u0023\-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70\-\udd71]|\ud83c[\udd7e\-\udd7f]|\ud83c\udd8e|\ud83c[\udd91\-\udd9a]|\ud83c[\udde6\-\uddff]|\ud83c[\ude01\-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32\-\ude3a]|\ud83c[\ude50\-\ude51]|\u203c|\u2049|[\u25aa\-\u25ab]|\u25b6|\u25c0|[\u25fb\-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600\-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9\-\u23f3]|[\u23f8\-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190\-\u21ff]|[\uE000\-\uF8FF]|\uD83C[\uDF00\-\uDFFF]|\uD83D[\uDC00\-\uDDFF])/g,
        ""
      )
      .replace(
        /[^A-Za-z0-9\w\.,\?""!@#\$%\^&\*\(\)\-_=\+;:<>\/\\\|\}\{\[\]`~\s\']*/g,
        ""
      );
    this.setState({ note: strReplace });
  };

  render() {
    const productData = this.props.product;
    return (
      <Modal
        show={this.props.trigger}
        className="modal-center"
        onHide={() => this.handleCloseModal()}
        key={this.state.i}
      >
        <Modal.Dialog className="modal-sm">
          <Modal.Body className="p-0">
            <div className="d-flex justify-content-end p-1">
              <span
                className="fs-40 material-icons-outlined"
                onClick={() => this.handleCloseModal()}
              >
                close
              </span>
            </div>
            <div className="row">
              <div className="container">
                <div className="row text-center px-20">
                  <div className="text-center pb-10">
                    <img
                      className="avatar avatar-xxl"
                      src={productData.image}
                    />
                    <h5 className="mt-3 mb-1">{productData.name}</h5>
                  </div>
                  <div className="d-flex justify-content-center pb-10">
                    <div className="custom-radio">
                      <label onClick={() => this.handlePlace(0)}>
                        <input
                          type="radio"
                          name="place"
                          defaultChecked={this.state.place === 1 ? "" : true}
                        />
                        <div className="box">
                          <div className="row">
                            <span className=" material-icons-outlined fs-30">
                              dining
                            </span>
                            <span> Dine In</span>
                          </div>
                        </div>
                      </label>
                    </div>
                    <div className="custom-radio">
                      <label onClick={() => this.handlePlace(1)}>
                        <input
                          type="radio"
                          value="1"
                          name="place"
                          defaultChecked={this.state.place === 1 ? true : ""}
                        />
                        <div className="box">
                          <div className="row">
                            <span className=" material-icons-outlined fs-30">
                              takeout_dining
                            </span>
                            <span> Take Away</span>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>

                  <div className="d-flex justify-content-center py-10">
                    <div className="btn-group">
                      <button
                        className="btn btn-square btn-danger px-35 cart_button"
                        onClick={() => this.handleDecreaseQty()}
                      >
                        <span className="material-icons-outlined">remove</span>
                      </button>
                      <button
                        className="btn btn-square btn-light px-40 cart_button"
                        disabled="disabled"
                      >
                        {this.state.qty}
                      </button>
                      <button
                        className="btn btn-square  btn-success px-35 cart_button"
                        onClick={() => this.handleIncreaseQty()}
                      >
                        <span className="material-icons-outlined">
                          add_circle_outline
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group p-10">
                      <label htmlFor="textarea">Order Notes</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        onChange={(e) => this.handleNote(e.target)}
                        value={this.props.product.prdnote}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 ">
                <button
                  type="button"
                  className="btn btn-lg w-100 btn-primary btn-multiline"
                  onClick={(e) => {
                    this.props.addToCart(
                      productData,
                      this.state.place,
                      this.state.note,
                      this.state.qty
                    );
                    this.handleCloseModal();
                  }}
                >
                  Add to cart
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal.Dialog>
      </Modal>
    );
  }
}

export default connect(() => ({}), { addToCart })(React.memo(AddToCartModal));
